import { parse as parseChrono } from "chrono-node"
import {
	add,
	addMonths,
	differenceInCalendarDays,
	format,
	isSameDay,
	nextMonday,
	set,
} from "date-fns"

import { getDateSuggestionsForInput } from "@/lib/dates"

export interface SnoozeOption {
	label: string
	value: Date
}

const atNine = (date: Date) =>
	set(date, { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 })

export function getSnoozePresets(now = new Date()): SnoozeOption[] {
	const laterToday = add(now, { hours: 3 })
	const tomorrow = atNine(add(now, { days: 1 }))
	const monday = atNine(nextMonday(now))

	return [
		...(isSameDay(laterToday, now)
			? [{ label: "Later today", value: laterToday }]
			: []),
		{ label: "Tomorrow", value: tomorrow },
		...(isSameDay(monday, tomorrow)
			? []
			: [{ label: "Monday", value: monday }]),
		{ label: "One week", value: add(now, { weeks: 1 }) },
		{ label: "One month", value: atNine(addMonths(now, 1)) },
	]
}

export function parseSnoozeQuery(query: string, now = new Date()) {
	const lowerQuery = query.trim().toLowerCase()
	if (!lowerQuery) return []

	const suggestions = getDateSuggestionsForInput(lowerQuery)
	if (suggestions.length > 0) return suggestions

	return parseChrono(lowerQuery, now, { forwardDate: true })
		.map((p) => ({ label: p.text, value: p.start.date() }))
		.filter((option) => option.value.getTime() > now.getTime())
}

export function formatSnoozeTime(value: Date, now = new Date()) {
	if (isSameDay(value, now)) return format(value, "h:mm a")
	const days = differenceInCalendarDays(value, now)
	if (days > 0 && days < 7) return format(value, "EEE h:mm a")
	return format(value, "EEE, MMM d, h:mm a")
}
